<template>
  <div>
    <div class="div-img-top body-width divcss5 pr-padding-bottom">
      <div class="font_zh ">
         {{$t("about.aboutus")}}
      </div>
      <div class="font_en font_en_top ">
        ABOUT US
      </div>
    </div>
    <div class="div-row row ">
      <div class=" body-width">
        <div class=" div-left div-left-content">
          <a  @click="setroters('about')">
            <img style="width: 55%" src="../../../assets/images/news1/news1.png" />
            </a>
        </div>
        <div class="div-right">
          <div class="main">
            <p class="indentation">{{$t("about.synopsis")}}</p>
          </div>
          <div class="about_content_more">
            <div  @mouseenter="enter" @mouseleave="leave" :class="isflag?'about_content_rect':'about_content_rect1'">
              <p><a @click="setroters('about')">{{$t("about.more")}}</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapMutations } from 'vuex'
  export default {
    name: "aboutcontent",
    data() {
      return {
        isflag: false,
        header:{
          showindex:false,
          showabout:true,
          showproduct:false,
          shownews:false,
          showjoin:false,
          showpartner:false,
          showcontact:false,
          showlanguage:false,
        }
      }
    },
    methods:{
      ...mapMutations(['setHeaderTitle']),
      setroters(src){
        this.switchStyle()
        this.$router.push(src);
      },
      switchStyle(){
        this.setHeaderTitle(this.header);
      },
      enter: function () {
        this.isflag = true;
      },
      leave: function () {
        this.isflag = false;
      }
    }
  }
</script>

<style scoped>
  div-content {
    margin-right: 15px;
  }

  .div-left-content {
    position: absolute;
    /* width: 500px; */
    line-height: 10px;
    align: left;
  }
  div-center {
    text-align: center;
  }
  .div-left {
    float: left;
  }
  .div-right {
    float: right;
    margin-right: 10px;
    padding-top: 100px;
  }
  .div-row {
    flex-wrap: wrap;
    margin-right: 0px;
    margin-left: 0px;
  }
  .main {
    position: relative;
    width: 520px;
    height: 394px;
    top: -70px
  }
  .about_content_font span{
    line-height: 28px;
  }
  .about_content_more{
    position: relative;
    bottom: 165px;
  }
  .about_content_rect1 {
    border: 1px dashed #FFFFFF ;
    border-radius:5px;
    font-size: 14px;
    width: 60px;
    height: 30px;
    line-height: 30px;
  }
  .about_content_rect {
    border: 1px dashed #2E79BE  ;
    border-radius:5px;
    width: 60px;
    height: 30px;
    color: #2E79BE;
    font-size: 14px;
    line-height: 30px;
  }
  .pr-padding-bottom{

   margin-bottom: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/contentcoms/indexcontentcoms/aboutpartcontent.vue